export const SIDEBAR_COLLAPSED_WIDTH = 98
export const SIDEBAR_OPEN_WIDTH = 280

// Sidebar padding 8px each side plus a 1px border leave 81px of content when closed.
// A 40px icon cell on the right edge sits at the same place in both widths.
export const ICON_CELL = 40
export const ICON_INSET = `${(SIDEBAR_COLLAPSED_WIDTH - 16 - 1 - ICON_CELL) / 2}px`

export const SIDEBAR_TRANSITION_MS = 300
export const SIDEBAR_TRANSITION = `${SIDEBAR_TRANSITION_MS / 1000}s ease`

export const reducedMotion = {
  '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
} as const

export const fade = (visible: boolean) => ({
  opacity: visible ? 1 : 0,
  transition: `opacity ${SIDEBAR_TRANSITION}`,
  pointerEvents: visible ? 'auto' : 'none',
  ...reducedMotion,
})
